var map = {
	"./exit-fullscreen.svg": 3556,
	"./fullscreen.svg": 8972,
	"./international.svg": 2054,
	"./language.svg": 7487,
	"./peoples.svg": 975,
	"./size.svg": 9394,
	"./theme.svg": 7492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;